<template>
  <div class="footer-bottom">
    <div class="footer-bottom-content">
      <div class="footer-copy">
        <p class="text-center">
          © Copyright {{ appName }} - Todos os direitos reservados.
        </p>
      </div>

      <div class="footer-signature">
        <a :href="linkUrl" target="_blank" rel="noopener">
          <img src="https://i.imgur.com/vfqNBLN.png" alt="Aglets" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DesenvolvidoPor",
  computed: {
    ...mapGetters(["siteConfig"]),
    appName() {
      return (this.siteConfig && this.siteConfig.app_name) || "";
    },
    linkUrl() {
      return `https://lp.aglets.com.br?utm_source=${encodeURIComponent(
        window?.location?.host
      )}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/sass/bootstrap/variables";

.footer-bottom {
  width: 100%;
  padding: 15px 20px;
  background: var(--brand-primary, $brand-primary);
  color: #ffffff;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  border-top: 1px solid #ccc;
  padding-top: 20px;
  margin: 0 auto 25px;
  max-width: 1330px;
}

.footer-copy {
  font-size: 0.92em;
  line-height: 1.6;
}

.footer-signature img {
  max-height: 22px;
  width: auto;
}

@media (max-width: 991px) {
  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
  }
}
</style>
